import { useState, type KeyboardEvent } from "react";
import { useApp } from "../../context/AppContext.js";

export function LoginScreen() {
  const { login, loginError } = useApp();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const handleSubmit = () => void login(username, password);

  const onKeyDown = (e: KeyboardEvent<HTMLInputElement>, next?: () => void) => {
    if (e.key !== "Enter") return;
    if (next) {
      next();
    } else {
      handleSubmit();
    }
  };

  return (
    <div className="login-screen">
      <div className="card login-card">
        <div className="login-logo-wrap">
          <span>AP</span>
        </div>
        <h2 className="login-title">Sign In</h2>
        <p className="login-subtitle">Enter your credentials to access the invoice manager.</p>

        {loginError && <div className="login-error">{loginError}</div>}

        <div className="form-group">
          <label className="inp-label">Username</label>
          <input
            className="inp"
            placeholder="Enter username"
            autoFocus
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            onKeyDown={(e) => onKeyDown(e, () => document.getElementById("login-password")?.focus())}
          />
        </div>
        <div className="form-group">
          <label className="inp-label">Password</label>
          <input
            id="login-password"
            className="inp"
            type="password"
            placeholder="Enter password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            onKeyDown={(e) => onKeyDown(e)}
          />
        </div>
        <button className="btn btn-primary btn-full" onClick={handleSubmit}>
          Sign In
        </button>
      </div>
    </div>
  );
}
